import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {translate} from 'views/module';

import CompactDropdown from 'views/scenes/client/detail/client_scenes/client_feed/header/client_details/dropdowns/CompactDropdown';
import {StageReasonDialog, useStageChange} from 'views/scenes/loom_lead/stage';

const StageDropdown = (props) => {
  const {clientId, label, selectedStage, onChanged} = props;
  const progressWrap = props.statusProgressWrap;

  const {pendingStage, selectStage, saveReason, closeReason} = useStageChange({
    clientId,
    selectedStage,
    onChanged,
    progressWrap,
  });

  const stages = Object.entries(translate('loomLead.Status'));

  return (
    <>
      <CompactDropdown
        getOptionKey={([key]) => key}
        getOptionLabel={([, value]) => value.Title}
        isOptionSelected={([key]) => selectedStage === key}
        label={label}
        menuLabel={label}
        onOptionSelect={([key]) => selectStage(key)}
        options={stages}
        value={selectedStage ? translate(`loomLead.Status.${selectedStage}.Title`) : '-'}
      />
      {
        pendingStage &&
        <StageReasonDialog stage={pendingStage} onClose={closeReason} onSave={saveReason} />
      }
    </>
  );
};

StageDropdown.propTypes = {
  clientId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selectedStage: PropTypes.string,
  onChanged: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(StageDropdown));
